export default {"src":"/_next/static/media/male_1.d7a08f27.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};